module.exports = __webpack_public_path__ + "img/bj.4918aa55.png";